import { useTranslation } from "react-i18next";
import ExpandableText from "../../../../components/app/ExpandableText";
import ScientificText from "../../../../components/ScientificText";
import type { ArticlePageArticle } from "../../hooks/useArticleData";
import { SectionTitle } from "../../../../components/ui/SectionTitle";

interface ArticleSectionResultsProps {
  article: ArticlePageArticle;
  isExpanded: boolean;
  setExpand: (isExpanded: boolean) => void;
}

export function ArticleSectionResults({
  article,
  isExpanded,
  setExpand,
}: ArticleSectionResultsProps) {
  const { t } = useTranslation();
  const results = article.results.filter((el) => el !== "");

  if (results.length === 0) return null;

  return (
    <section data-gtm-section="results" data-gtm-order="5">
      <SectionTitle title={t("Results")} className="mb-4" />
      <ExpandableText
        isExpanded={isExpanded}
        setExpand={setExpand}
        lines={10}
        variant="list"
      >
        <ul>
          {results.map((el, index) => (
            <li key={index}>
              <ScientificText>{el}</ScientificText>
            </li>
          ))}
        </ul>
      </ExpandableText>
    </section>
  );
}
